//@ts-nocheck
import { useState } from "react";
import "./ReportComponents.css";
import moment from "moment";
import MapAnalysisInputs from "./MapAnalysisInputs";
import { Carousel } from "react-responsive-carousel";
import RecommendationBox from "./RecommendationBox";

const DataAnalysisReport = ({ props }) => {
  const [powerAnalysisItems, setPowerAnalysisItems] = useState({
    Analysis_Inputs: false,
    Output: true,
  });

  const ssdRecommendationsItems = [
    {
      header: "SSD",
      items: [
        { value: "120 WHr", label: "Capacity", class: "reportDataBoxHalfBox reportDataBoxHalfBoxLeft" },
        { value: "<Values>", label: "<Params>", class: "reportDataBoxHalfBox reportDataBoxHalfBoxRight" },
      ],
      icon: require("../../ImageSvgs/Satellite.svg").default,
      iconSvg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
          <path
            d="M9.1956 6.23008C9.96958 6.2314 10.7207 5.96798 11.3242 5.4836C11.3922 5.42959 11.4479 5.36171 11.4876 5.28448C11.5273 5.20724 11.5501 5.12244 11.5545 5.03571C11.5596 4.94382 11.545 4.85189 11.5117 4.76607C11.4784 4.68026 11.4272 4.60252 11.3615 4.53806L9.63127 2.80872C9.874 2.56611 10.1292 2.31107 10.3719 2.06224C10.4217 2.0187 10.4653 1.97515 10.5151 1.92539C10.5705 1.86644 10.6014 1.78857 10.6014 1.70766C10.6014 1.62676 10.5705 1.54889 10.5151 1.48994C10.4861 1.46079 10.4517 1.43765 10.4138 1.42186C10.3759 1.40607 10.3352 1.39794 10.2941 1.39794C10.253 1.39794 10.2124 1.40607 10.1744 1.42186C10.1365 1.43765 10.1021 1.46079 10.0732 1.48994C9.77442 1.78231 9.48812 2.07468 9.18938 2.36705L7.45914 0.637712C7.3938 0.573185 7.31588 0.522771 7.23023 0.489598C7.14457 0.456425 7.05301 0.441201 6.96123 0.444872C6.87461 0.449898 6.79 0.47297 6.71283 0.512607C6.63565 0.552244 6.56763 0.607571 6.51311 0.675036C5.99618 1.32042 5.73281 2.13225 5.77247 2.95801L4.87001 3.86623L3.41984 2.41682C3.36305 2.35778 3.29491 2.3108 3.21951 2.27872C3.14411 2.24663 3.06301 2.2301 2.98106 2.2301C2.89911 2.2301 2.81801 2.24663 2.74261 2.27872C2.66721 2.3108 2.59907 2.35778 2.54228 2.41682L0.625322 4.33278C0.509401 4.44933 0.444336 4.60699 0.444336 4.77133C0.444336 4.93568 0.509401 5.09334 0.625322 5.20989L2.0786 6.6593L1.82342 6.90813C1.51557 7.21708 1.34272 7.63536 1.34272 8.07139C1.34272 8.50743 1.51557 8.9257 1.82342 9.23465L2.76322 10.174C2.91554 10.3277 3.09681 10.4497 3.29658 10.5329C3.49635 10.6162 3.71065 10.6591 3.92709 10.6591C4.14353 10.6591 4.35783 10.6162 4.5576 10.5329C4.75736 10.4497 4.93864 10.3277 5.09095 10.174L5.33991 9.92514L6.79007 11.3746C6.90668 11.4904 7.06443 11.5554 7.22886 11.5554C7.39328 11.5554 7.55103 11.4904 7.66764 11.3746L9.58459 9.45237C9.70051 9.33582 9.76558 9.17816 9.76558 9.01382C9.76558 8.84948 9.70051 8.69181 9.58459 8.57526L8.14065 7.13207L9.04312 6.22386C9.09378 6.22891 9.1447 6.23099 9.1956 6.23008ZM1.06099 4.77444L2.98417 2.85226L4.42811 4.30168L2.51427 6.21764L1.06099 4.77444ZM9.14581 9.01693L7.22886 10.9329L5.77869 9.48348L7.69565 7.56752L9.14581 9.01693ZM5.89072 3.72315C6.04815 4.29334 6.35125 4.8128 6.77027 5.23051C7.18928 5.64821 7.7098 5.94981 8.28069 6.10566L4.64595 9.73853C4.45435 9.92967 4.19469 10.037 3.92398 10.037C3.65326 10.037 3.39361 9.92967 3.20201 9.73853L2.25598 8.79299C2.06473 8.60148 1.95732 8.34196 1.95732 8.07139C1.95732 7.80082 2.06473 7.5413 2.25598 7.34979L5.89072 3.72315ZM7.21018 4.78689C6.72084 4.30418 6.43023 3.65572 6.39567 2.96941C6.3611 2.2831 6.5851 1.60876 7.02347 1.07938L8.97154 3.02644L10.9258 4.97973L10.9383 4.99839C10.3996 5.42755 9.72159 5.64323 9.03382 5.60422C8.34606 5.5652 7.69681 5.27421 7.21018 4.78689Z"
            fill="#F0F0F0"
          />
        </svg>
      ),
      recommendationAction: "+ Add to Satellite",
    },
  ];

  const edgeRecommendationsItems = [
    {
      header: "EDGE Capability",
      items: [
        { value: "60W", label: "Peak Power", class: "reportDataBoxHalfBox reportDataBoxHalfBoxLeft" },
        { value: "<Values>", label: "<Params>", class: "reportDataBoxHalfBox reportDataBoxHalfBoxRight" },
      ],
      icon: require("../../ImageSvgs/Satellite.svg").default,
      iconSvg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
          <path
            d="M9.1956 6.23008C9.96958 6.2314 10.7207 5.96798 11.3242 5.4836C11.3922 5.42959 11.4479 5.36171 11.4876 5.28448C11.5273 5.20724 11.5501 5.12244 11.5545 5.03571C11.5596 4.94382 11.545 4.85189 11.5117 4.76607C11.4784 4.68026 11.4272 4.60252 11.3615 4.53806L9.63127 2.80872C9.874 2.56611 10.1292 2.31107 10.3719 2.06224C10.4217 2.0187 10.4653 1.97515 10.5151 1.92539C10.5705 1.86644 10.6014 1.78857 10.6014 1.70766C10.6014 1.62676 10.5705 1.54889 10.5151 1.48994C10.4861 1.46079 10.4517 1.43765 10.4138 1.42186C10.3759 1.40607 10.3352 1.39794 10.2941 1.39794C10.253 1.39794 10.2124 1.40607 10.1744 1.42186C10.1365 1.43765 10.1021 1.46079 10.0732 1.48994C9.77442 1.78231 9.48812 2.07468 9.18938 2.36705L7.45914 0.637712C7.3938 0.573185 7.31588 0.522771 7.23023 0.489598C7.14457 0.456425 7.05301 0.441201 6.96123 0.444872C6.87461 0.449898 6.79 0.47297 6.71283 0.512607C6.63565 0.552244 6.56763 0.607571 6.51311 0.675036C5.99618 1.32042 5.73281 2.13225 5.77247 2.95801L4.87001 3.86623L3.41984 2.41682C3.36305 2.35778 3.29491 2.3108 3.21951 2.27872C3.14411 2.24663 3.06301 2.2301 2.98106 2.2301C2.89911 2.2301 2.81801 2.24663 2.74261 2.27872C2.66721 2.3108 2.59907 2.35778 2.54228 2.41682L0.625322 4.33278C0.509401 4.44933 0.444336 4.60699 0.444336 4.77133C0.444336 4.93568 0.509401 5.09334 0.625322 5.20989L2.0786 6.6593L1.82342 6.90813C1.51557 7.21708 1.34272 7.63536 1.34272 8.07139C1.34272 8.50743 1.51557 8.9257 1.82342 9.23465L2.76322 10.174C2.91554 10.3277 3.09681 10.4497 3.29658 10.5329C3.49635 10.6162 3.71065 10.6591 3.92709 10.6591C4.14353 10.6591 4.35783 10.6162 4.5576 10.5329C4.75736 10.4497 4.93864 10.3277 5.09095 10.174L5.33991 9.92514L6.79007 11.3746C6.90668 11.4904 7.06443 11.5554 7.22886 11.5554C7.39328 11.5554 7.55103 11.4904 7.66764 11.3746L9.58459 9.45237C9.70051 9.33582 9.76558 9.17816 9.76558 9.01382C9.76558 8.84948 9.70051 8.69181 9.58459 8.57526L8.14065 7.13207L9.04312 6.22386C9.09378 6.22891 9.1447 6.23099 9.1956 6.23008ZM1.06099 4.77444L2.98417 2.85226L4.42811 4.30168L2.51427 6.21764L1.06099 4.77444ZM9.14581 9.01693L7.22886 10.9329L5.77869 9.48348L7.69565 7.56752L9.14581 9.01693ZM5.89072 3.72315C6.04815 4.29334 6.35125 4.8128 6.77027 5.23051C7.18928 5.64821 7.7098 5.94981 8.28069 6.10566L4.64595 9.73853C4.45435 9.92967 4.19469 10.037 3.92398 10.037C3.65326 10.037 3.39361 9.92967 3.20201 9.73853L2.25598 8.79299C2.06473 8.60148 1.95732 8.34196 1.95732 8.07139C1.95732 7.80082 2.06473 7.5413 2.25598 7.34979L5.89072 3.72315ZM7.21018 4.78689C6.72084 4.30418 6.43023 3.65572 6.39567 2.96941C6.3611 2.2831 6.5851 1.60876 7.02347 1.07938L8.97154 3.02644L10.9258 4.97973L10.9383 4.99839C10.3996 5.42755 9.72159 5.64323 9.03382 5.60422C8.34606 5.5652 7.69681 5.27421 7.21018 4.78689Z"
            fill="#F0F0F0"
          />
        </svg>
      ),
      recommendationAction: "+ Add to Satellite",
    },
  ];

  const ioInterfaceRecommendationsItems = [
    {
      header: "IO Interfaces bandwidth",
      items: [
        { value: "100W", label: "Peak Power", class: "reportDataBoxHalfBox reportDataBoxHalfBoxLeft" },
        { value: "<Values>", label: "<Params>", class: "reportDataBoxHalfBox reportDataBoxHalfBoxRight" },
      ],
      icon: require("../../ImageSvgs/Satellite.svg").default,
      iconSvg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
          <path
            d="M9.1956 6.23008C9.96958 6.2314 10.7207 5.96798 11.3242 5.4836C11.3922 5.42959 11.4479 5.36171 11.4876 5.28448C11.5273 5.20724 11.5501 5.12244 11.5545 5.03571C11.5596 4.94382 11.545 4.85189 11.5117 4.76607C11.4784 4.68026 11.4272 4.60252 11.3615 4.53806L9.63127 2.80872C9.874 2.56611 10.1292 2.31107 10.3719 2.06224C10.4217 2.0187 10.4653 1.97515 10.5151 1.92539C10.5705 1.86644 10.6014 1.78857 10.6014 1.70766C10.6014 1.62676 10.5705 1.54889 10.5151 1.48994C10.4861 1.46079 10.4517 1.43765 10.4138 1.42186C10.3759 1.40607 10.3352 1.39794 10.2941 1.39794C10.253 1.39794 10.2124 1.40607 10.1744 1.42186C10.1365 1.43765 10.1021 1.46079 10.0732 1.48994C9.77442 1.78231 9.48812 2.07468 9.18938 2.36705L7.45914 0.637712C7.3938 0.573185 7.31588 0.522771 7.23023 0.489598C7.14457 0.456425 7.05301 0.441201 6.96123 0.444872C6.87461 0.449898 6.79 0.47297 6.71283 0.512607C6.63565 0.552244 6.56763 0.607571 6.51311 0.675036C5.99618 1.32042 5.73281 2.13225 5.77247 2.95801L4.87001 3.86623L3.41984 2.41682C3.36305 2.35778 3.29491 2.3108 3.21951 2.27872C3.14411 2.24663 3.06301 2.2301 2.98106 2.2301C2.89911 2.2301 2.81801 2.24663 2.74261 2.27872C2.66721 2.3108 2.59907 2.35778 2.54228 2.41682L0.625322 4.33278C0.509401 4.44933 0.444336 4.60699 0.444336 4.77133C0.444336 4.93568 0.509401 5.09334 0.625322 5.20989L2.0786 6.6593L1.82342 6.90813C1.51557 7.21708 1.34272 7.63536 1.34272 8.07139C1.34272 8.50743 1.51557 8.9257 1.82342 9.23465L2.76322 10.174C2.91554 10.3277 3.09681 10.4497 3.29658 10.5329C3.49635 10.6162 3.71065 10.6591 3.92709 10.6591C4.14353 10.6591 4.35783 10.6162 4.5576 10.5329C4.75736 10.4497 4.93864 10.3277 5.09095 10.174L5.33991 9.92514L6.79007 11.3746C6.90668 11.4904 7.06443 11.5554 7.22886 11.5554C7.39328 11.5554 7.55103 11.4904 7.66764 11.3746L9.58459 9.45237C9.70051 9.33582 9.76558 9.17816 9.76558 9.01382C9.76558 8.84948 9.70051 8.69181 9.58459 8.57526L8.14065 7.13207L9.04312 6.22386C9.09378 6.22891 9.1447 6.23099 9.1956 6.23008ZM1.06099 4.77444L2.98417 2.85226L4.42811 4.30168L2.51427 6.21764L1.06099 4.77444ZM9.14581 9.01693L7.22886 10.9329L5.77869 9.48348L7.69565 7.56752L9.14581 9.01693ZM5.89072 3.72315C6.04815 4.29334 6.35125 4.8128 6.77027 5.23051C7.18928 5.64821 7.7098 5.94981 8.28069 6.10566L4.64595 9.73853C4.45435 9.92967 4.19469 10.037 3.92398 10.037C3.65326 10.037 3.39361 9.92967 3.20201 9.73853L2.25598 8.79299C2.06473 8.60148 1.95732 8.34196 1.95732 8.07139C1.95732 7.80082 2.06473 7.5413 2.25598 7.34979L5.89072 3.72315ZM7.21018 4.78689C6.72084 4.30418 6.43023 3.65572 6.39567 2.96941C6.3611 2.2831 6.5851 1.60876 7.02347 1.07938L8.97154 3.02644L10.9258 4.97973L10.9383 4.99839C10.3996 5.42755 9.72159 5.64323 9.03382 5.60422C8.34606 5.5652 7.69681 5.27421 7.21018 4.78689Z"
            fill="#F0F0F0"
          />
        </svg>
      ),
      recommendationAction: "+ Add to Satellite",
    },
  ];

  const [aoiProfileValues, setAoiProfileValues] = useState([
    { label: "Digital TDI Index", value: "<>" },
    { label: "Imaging time", value: "24 mins" },
    { label: "Image data Size", value: "45" },
    { label: "No of Image Sports", value: "16" },
    { label: "Data Generated", value: "16" },
    { label: "Data Downloaded", value: "16" },
    { label: "Dumping Imaging", value: "0.80" },
  ]);

  const AoiProfileOutputDiv = ({ label, value }) => (
    <>
      <div className="reportDataBoxText">{label}</div>
      <div className="reportDataBoxData">{value}</div>
    </>
  );

  const spaceCraftObject = [
    {
      title: "SpaceObject_01",
      planes: [
        { title: "Plane_01", satellites: [{ title: "Mission_Sat_01" }, { title: "Mission_Sat_02" }, { title: "Mission_Sat_03" }] },
        { title: "Plane_02", satellites: [{ title: "Mission_Sat_04" }] },
      ],
      startTime: "2023-10-10T08:12:36Z",
      duration: "10 hours",
    },
  ];

  return (
    <div className="reportDiv">
      <div className="reportTitleDiv">
        <div className="reportTitle">Data Analysis</div>
        <div className="reportDate">{moment(new Date).format('DD - MM - HH - YYYY')}</div>
      </div>
      <div className="modalCheckboxDiv reportCheckBoxDiv">
        <input type="checkbox" name="checkboxName" id="checkboxId" className="modalCheckbox" />
        <button
          className="modalDropDownIconBtn"
          onClick={() =>
            setPowerAnalysisItems({
              Analysis_Inputs: !powerAnalysisItems.Analysis_Inputs,
              Output: powerAnalysisItems.Output,
            })
          }
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d={powerAnalysisItems.Analysis_Inputs ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
              stroke="#F0F0F0"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="modalCheckboxText modalWhiteSubHeader">Analysis Inputs</div>
      </div>

      {powerAnalysisItems.Analysis_Inputs && <MapAnalysisInputs spaceCraftObject={spaceCraftObject} />}

      <div className="modalCheckboxDiv reportCheckBoxDiv">
        <input type="checkbox" name="checkboxName" id="checkboxId" className="modalCheckbox" />
        <button
          className="modalDropDownIconBtn"
          onClick={() =>
            setPowerAnalysisItems({
              Analysis_Inputs: powerAnalysisItems.Analysis_Inputs,
              Output: !powerAnalysisItems.Output,
            })
          }
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d={powerAnalysisItems.Output ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
              stroke="#F0F0F0"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="modalCheckboxText modalWhiteSubHeader">Output</div>
        <button className="reportCommentBtn">
          <img src={require("../../ImageSvgs/Comment-Button.svg").default} />
        </button>
        <button className="reportCommentBtn reportTagBtn">
          <img src={require("../../ImageSvgs/Tag-Button.svg").default} />
        </button>
      </div>

      {powerAnalysisItems.Output && (
        <>
          <div className="modalCheckboxDiv reportCheckBoxDiv">
            <div className="reportConfigHeader white analysisPlaneHeader" style={{ width: "calc(70% - 35px)" }}>
              AOI_01
            </div>
            <div className="selectBorderDiv" style={{ width: "30%" }}>
              <select
                name="reportOutputTime"
                id="powerDropdown"
                className={"reportConfigDropdown reportAnalysisDropdown"}
                onChange={(event) => {
                  event.target.value != "" ? (event.target.style.color = "#CCF54E") : (event.target.style.color = "#F2A93B");
                }}
              >
                <option selected hidden value="">
                  Per Orbit
                </option>
                <option value="Orbit 1">Orbit 1</option>
                <option value="Orbit 2">Orbit 2</option>
                <option value="Orbit 3">Orbit 3</option>
              </select>
            </div>
          </div>

          <div className="reportDataBox reportDataBoxHeight">{aoiProfileValues.map(AoiProfileOutputDiv)}</div>

          <div className="reportText" style={{ cursor: "pointer" }}>
            &lt;Recommendations&gt;
          </div>
          <div className="reportDataBox reportRecommendationsBox pb-2">
            <Carousel showThumbs={false} showStatus={false}>
              {/* Add your recommendation slides here */}
              <RecommendationBox recommendationsItems={ssdRecommendationsItems} />
              <RecommendationBox recommendationsItems={ssdRecommendationsItems} />
            </Carousel>
          </div>
          <div className="reportDataBox reportRecommendationsBox pb-2">
            <Carousel showThumbs={false} showStatus={false}>
              {/* Add your recommendation slides here */}
              <RecommendationBox recommendationsItems={edgeRecommendationsItems} />
              <RecommendationBox recommendationsItems={edgeRecommendationsItems} />
            </Carousel>
          </div>
          <div className="reportDataBox reportRecommendationsBox pb-2">
            <Carousel showThumbs={false} showStatus={false}>
              {/* Add your recommendation slides here */}
              <RecommendationBox recommendationsItems={ioInterfaceRecommendationsItems} />
              <RecommendationBox recommendationsItems={ioInterfaceRecommendationsItems} />
            </Carousel>
          </div>
        </>
      )}
    </div>
  );
};

export default DataAnalysisReport;
